import {
  IncentiveCategory,
  IncentiveLifecycleStatus,
} from '@varo/graphql-schema-types';
import { VaroCategories } from 'shared/analytics/types/categories';
import { ButtonComponentAnalytics } from 'shared/analytics/types/componentEvents';
import { VaroPressableName } from 'shared/analytics/types/pressableNames';
import {
  VaroSubCategories,
  VaroSubCategoryFor,
} from 'shared/analytics/types/subCategories';

export const IncentiveScreenNames = {
  INTRO: 'incentive_intro',
  HOW_IT_WORKS: 'incentive_how_it_works',
  OPTED_IN: 'incentive_opted_in',
  TRACKER: 'incentive_tracker',
  WINNER: 'incentive_winner',
  NOT_AVAILABLE: 'incentive_not_available',
  UNSUPPORTED_CONTENT: 'incentive_unsupported_content',
  ERROR: 'incentive_error',
} as const;

export type IncentiveScreenName =
  (typeof IncentiveScreenNames)[keyof typeof IncentiveScreenNames];

export const IncentiveComponentNames = {
  PREREQUISITE_SHEET: 'incentive_prerequisite_sheet',
  ACCOUNT_CARD: 'incentive_account_card',
} as const;

export type IncentiveComponentName =
  (typeof IncentiveComponentNames)[keyof typeof IncentiveComponentNames];

export const INCENTIVE_COMPONENT_TYPES: Record<IncentiveComponentName, string> =
  {
    [IncentiveComponentNames.PREREQUISITE_SHEET]: 'bottom_sheet',
    [IncentiveComponentNames.ACCOUNT_CARD]: 'card',
  };

export const IncentiveErrorSteps = {
  STATUS: 'incentive_status',
  PROGRAM: 'incentive_program',
  PROGRESS: 'incentive_progress',
  OPT_IN: 'opt_in',
} as const;

export type IncentiveErrorStep =
  (typeof IncentiveErrorSteps)[keyof typeof IncentiveErrorSteps];

type IncentiveSubCategory = VaroSubCategoryFor<VaroCategories.INCENTIVE>;

const INCENTIVE_SUB_CATEGORIES: Record<
  IncentiveCategory,
  IncentiveSubCategory
> = {
  [IncentiveCategory.Sweepstakes]: VaroSubCategories.INCENTIVE.SWEEPSTAKES,
};

export interface IncentiveAnalyticsContext {
  incentiveType?: IncentiveCategory;
  incentiveProgramId?: string;
  lifecycleStatus?: IncentiveLifecycleStatus;
}

export const getIncentiveSubCategory = (
  incentiveType: IncentiveCategory | undefined,
): IncentiveSubCategory | undefined =>
  incentiveType ? INCENTIVE_SUB_CATEGORIES[incentiveType] : undefined;

export const getIncentiveAnalyticsProperties = ({
  incentiveType,
  incentiveProgramId,
  lifecycleStatus,
}: IncentiveAnalyticsContext) => ({
  incentive_program_id: incentiveProgramId,
  incentive_type: incentiveType?.toLowerCase(),
  lifecycle_status: lifecycleStatus?.toLowerCase(),
});

export const getIncentiveButtonAnalytics = (
  incentiveType: IncentiveCategory,
  pressableName: VaroPressableName,
): ButtonComponentAnalytics => ({
  pressableName,
  category: VaroCategories.INCENTIVE,
  subCategory: getIncentiveSubCategory(incentiveType),
});
